import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async searchSurgeryByPostcode(payload, options) {
    try {
      const query = options && Object.keys(options).length ? `?${qs.stringify(options)}` : '';
      const response = await axiosPrivate.post(`/surgeries/search${query}`, payload);

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error.response.data.error) helpers.throwError(error.response.data.error);
      throw error;
    }
  },
};
